package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.filter_aeroguard
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun AeroguardSwitch(
    modifier: Modifier,
    model: MainScreenModel
) {
    val state by model.states.collectAsState()

    MapOverlayCard(modifier) {
        Row(
            modifier = Modifier.padding(8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            TextNormal(
                text = Res.string.filter_aeroguard.localized(),
                fontSize = LocalFontSizes.current.map.activityLightning
            )

            Checkbox(
                checked = state.aeroguardLocationsShow,
                onCheckedChange = {
                    model.setFilterAeroguard(it)
                }
            )
        }
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun Preview() {
    HotPreviewApp(
        Modifier.fillMaxSize().padding(10.dp),
        isDarkTheme = isSystemInDarkTheme()
    ) {
        AeroguardSwitch(
            Modifier.fillMaxSize(),
            FakeMainScreenModel()
        )
    }
}
